import React from 'react';
import CompanyFoldersTable from '@components/pages/admin/folder/CompanyFoldersTable.tsx';

interface ComponentProps {
  companyId: string;
}

/** Admin company detail → Folders section (RD-2977: shares the table/editor with the customer's Company profile). */
const AdminCompanyFolders: React.FC<ComponentProps> = ({ companyId }) => <CompanyFoldersTable mode={'admin'} companyId={companyId} />;

export default AdminCompanyFolders;
